import { HttpHeaders } from '@angular/common/http';

import { CustomerAccountDto } from '@core/model/customer-account-dto';
import { CustomerDto } from '@core/model/customer-dto';
import { IdName } from '@core/model/id-name';

import { SweetAlertOptions } from 'sweetalert2';

export function getSweetAlertOptions(
  messageParam: string,
  confirmButtonTextParam: string,
  showCancelButtonParam = false,
  cancelButtonTextParam = '',
  cancelButtonColorParam = '',
  confirmButtonColorParam = '',
  titleParam = 'Info',
  confirmButtonClass: string = 'mat-flat-button mat-primary',
  cancelButtonClass: string = 'mat-flat-button mat-accent',
  buttonsStyling?: boolean,
  heightAuto?: boolean
) {
  let options: SweetAlertOptions = {
    title: titleParam,
    html: messageParam,
    confirmButtonColor: confirmButtonColorParam,
    cancelButtonColor: cancelButtonColorParam,
    confirmButtonText: confirmButtonTextParam,
    showCancelButton: showCancelButtonParam,
    cancelButtonText: cancelButtonTextParam,
    confirmButtonClass: confirmButtonClass,
    cancelButtonClass: cancelButtonClass,
    buttonsStyling: buttonsStyling,
    heightAuto: heightAuto,
    allowOutsideClick: false,
    allowEscapeKey: false,
  };

  return options;
}

export function getHttpHeaders() {
  return new HttpHeaders({
    'Content-Type': 'application/json',
  });
}

export function getCustomerDtoInSession(): CustomerDto {
  const customerDto: CustomerDto = JSON.parse(sessionStorage.getItem('customerDto'));
  return customerDto;
}

export function getCustomerAccountDtoInSession(): CustomerAccountDto {
  const CustomerAccountDto: CustomerAccountDto = JSON.parse(sessionStorage.getItem('customerDto'));
  return CustomerAccountDto;
}

export function obtainTooltipDescription(tooltipInformation: IdName[], key: string): string {
  return tooltipInformation.find((element) => element.key === key).name;
}

export function isWhitheSpaces(value: any): boolean {
  return value == 0 ? true : (value?.toString() || '').trim().length === 0;
}
